import * as React from 'react';
/**
 *
 * Original name: tag
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=11525%3A3
 *
 */
export const TagLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.38 4.37h7.071l7.551 7.55c.855.855.855 2.24 0 3.094l-3.977 3.978a2.188 2.188 0 0 1-3.094 0l-7.55-7.551V4.37Zm1.5 1.5v4.95l7.112 7.111a.688.688 0 0 0 .972 0l3.978-3.977a.687.687 0 0 0 0-.973L10.83 5.87H5.88Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M7.787 7.771a1.16 1.16 0 0 0 0 1.768 1.16 1.16 0 0 0 1.768 0 1.16 1.16 0 0 0 0-1.768 1.16 1.16 0 0 0-1.768 0Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
